/** Cliente HTTP da API. Mesma origem: o cookie de sessão vai sozinho. */
export class ErroApi extends Error {
  constructor(
    public readonly status: number,
    mensagem: string,
    public readonly codigo?: string,
  ) {
    super(mensagem);
  }
}

async function requisitar<T>(metodo: string, caminho: string, corpo?: unknown): Promise<T> {
  let resp: Response;
  try {
    resp = await fetch(`/api${caminho}`, {
      method: metodo,
      credentials: "same-origin",
      headers: corpo === undefined ? undefined : { "Content-Type": "application/json" },
      body: corpo === undefined ? undefined : JSON.stringify(corpo),
    });
  } catch {
    throw new ErroApi(0, "Sem conexão. Verifique a internet.");
  }
  if (resp.status === 401 && !caminho.startsWith("/auth/login")) {
    window.dispatchEvent(new CustomEvent("ydchat:sessao-expirada"));
  }
  if (resp.status === 403 && resp.headers.get("content-type")?.includes("json")) {
    const corpo = (await resp.clone().json()) as { codigo?: string };
    if (corpo.codigo === "trocar_senha")
      window.dispatchEvent(new CustomEvent("ydchat:trocar-senha"));
  }
  const dados = resp.headers.get("content-type")?.includes("json") ? await resp.json() : null;
  if (!resp.ok) {
    const d = dados as { erro?: string; codigo?: string } | null;
    throw new ErroApi(resp.status, d?.erro ?? "Algo deu errado. Tente de novo.", d?.codigo);
  }
  return dados as T;
}

export const api = {
  get: <T>(c: string) => requisitar<T>("GET", c),
  post: <T>(c: string, corpo?: unknown) => requisitar<T>("POST", c, corpo ?? {}),
  patch: <T>(c: string, corpo?: unknown) => requisitar<T>("PATCH", c, corpo ?? {}),
  put: <T>(c: string, corpo?: unknown) => requisitar<T>("PUT", c, corpo ?? {}),
  del: <T>(c: string) => requisitar<T>("DELETE", c),
};
